module.exports = __webpack_public_path__ + "img/trip.781261bd.svg";